import { render } from "./SecurityStatusLabel.vue?vue&type=template&id=3a440e5d&scoped=true"
import script from "./SecurityStatusLabel.vue?vue&type=script&lang=js"
export * from "./SecurityStatusLabel.vue?vue&type=script&lang=js"

import "./SecurityStatusLabel.vue?vue&type=style&index=0&id=3a440e5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a440e5d"]])

export default __exports__